const Navigator = ({ title }) => {
    return <div className="navigator">
        <span className="butons">
            <span className="bg-red" ></span>
            <span className="bg-yellow" ></span>
            <span className="bg-green" ></span>
        </span>

        <span>
            <small>
                {title}
            </small>
        </span>
        <small></small>
    </div>
}

export default Navigator;